const dom = {
    homepageHero: $('.homepage-hero__inner'),
};

const initHeroSlider = () => {
    loadHeroSlider();
    $('.homepage-hero__inner').each(function() {
        var slideSpeed = $(this).data('slide-milliseconds');
        var autoplayIsChecked = $(this).data('slide-autoplay');
        var slideCount = $(this).find('.homepage-hero__slide').length;

        // Initialize slick only if there is more than one slide
        if (slideCount > 1) {
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                autoplay: autoplayIsChecked,
                autoplaySpeed: slideSpeed
            });
        }
    });
};

const loadHeroSlider = () => {
    document.addEventListener("shopify:section:load", function(event) {
        if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].homepage-hero__inner')) {
            initHeroSlider();
        }
    });
};
 
export default initHeroSlider;